export default __webpack_public_path__ + "static/media/protocolVoteBkg.985aa10b.svg";